interface Props {
  size?: number
}

function BanName({ size = 48 }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="24" fill="#FF5AFE" opacity="0.16"></circle>
      <path
        fill="#FF5AFE"
        fillRule="evenodd"
        d="M33.206 20.106c-.53-1.232-1.24-2.295-2.13-3.186-.889-.89-1.952-1.6-3.19-2.128A9.8 9.8 0 0024 14c-1.354 0-2.65.264-3.887.792-1.237.527-2.3 1.237-3.19 2.128-.89.891-1.6 1.954-2.129 3.186A9.75 9.75 0 0014 23.993c0 1.359.265 2.657.794 3.894.53 1.237 1.24 2.301 2.13 3.193.889.891 1.952 1.6 3.19 2.128A9.8 9.8 0 0024 34c1.354 0 2.65-.264 3.887-.792s2.3-1.237 3.19-2.128c.89-.892 1.6-1.956 2.129-3.193A9.794 9.794 0 0034 23.994a9.752 9.752 0 00-.794-3.888zm-15.13 7.768a6.964 6.964 0 01-1.16-3.88c0-1.281.318-2.466.951-3.557a7.022 7.022 0 012.578-2.583A6.941 6.941 0 0124 16.907c1.433 0 2.734.394 3.907 1.181l-9.831 9.786zm10.937 1.143a7.056 7.056 0 001.51-2.265c.373-.879.56-1.798.56-2.759 0-1.393-.377-2.669-1.132-3.828l-9.818 9.773A6.977 6.977 0 0024 31.093c.963 0 1.881-.189 2.754-.565a7.202 7.202 0 002.259-1.511z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default BanName
